import { useMemo } from "react";

const normalize = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

/**
 * Surligne les occurrences de `term` dans `text`.
 * Retourne un tableau de chunks (string ou span avec surlignage).
 */
export function highlightChunks(text, term) {
  if (!text || typeof text !== "string") return [{ type: "text", value: text || "" }];
  if (!term || !term.trim()) return [{ type: "text", value: text }];

  const normalizedTerm = normalize(term);
  const chunks = [];
  let pos = 0;

  while (pos < text.length) {
    const rest = text.slice(pos);
    const normRest = normalize(rest);
    const found = normRest.indexOf(normalizedTerm);

    if (found === -1) {
      if (pos < text.length) chunks.push({ type: "text", value: text.slice(pos) });
      break;
    }
    const actualStart = pos + found;
    const actualEnd = actualStart + term.length;
    const before = text.slice(pos, actualStart);
    if (before) chunks.push({ type: "text", value: before });
    chunks.push({ type: "mark", value: text.slice(actualStart, actualEnd) });
    pos = actualEnd;
  }

  return chunks;
}

/**
 * Composant qui affiche du texte avec le terme recherché surligné.
 */
export default function HighlightText({ text, term, as: Tag = "span", markClassName = "ta-search-highlight", ...props }) {
  const chunks = useMemo(() => highlightChunks(text, term), [text, term]);

  if (!text && text !== 0) return <Tag {...props} />;
  if (chunks.length === 1 && chunks[0].type === "text") {
    return <Tag {...props}>{chunks[0].value}</Tag>;
  }

  return (
    <Tag {...props}>
      {chunks.map((chunk, i) =>
        chunk.type === "mark" ? (
          <mark key={i} className={markClassName}>
            {chunk.value}
          </mark>
        ) : (
          <span key={i}>{chunk.value}</span>
        )
      )}
    </Tag>
  );
}
